import SingleSelectQuestionTemplate from '~/pages/anatomyV2/libs/components/SingleSelectQuestionTemplate'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 6

const FocusAbilityAnatomyV2 = (props: TPageProps) => (
  <SingleSelectQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.focusAbility.title"
    options={[
      {
        key: 'mostTasks',
        i18nKey: 'onboarding.focusAbility.options.mostTasks',
      },
      {
        key: 'distractedSometimes',
        i18nKey: 'onboarding.focusAbility.options.distractedSometimes',
      },
      {
        key: 'loseAttentionEasily',
        i18nKey: 'onboarding.focusAbility.options.loseAttentionEasily',
      },
    ]}
    question="How would you describe your ability to keep focus?"
  />
)

export default FocusAbilityAnatomyV2
